import Individual from './Individual'

export default Individual;